class StormlyService {
  loadAnaliticsScript(stormlyKey: string) {
    //@ts-ignore
    !(function () {
      //@ts-ignore
      var analytics = (window.analytics = window.analytics || []);
      if (!analytics.initialize)
        if (analytics.invoked)
          window.console &&
            console.error &&
            console.error("Segment snippet included twice.");
        else {
          analytics.invoked = !0;
          analytics.methods = [
            "trackSubmit",
            "trackClick",
            "trackLink",
            "trackForm",
            "pageview",
            "identify",
            "reset",
            "group",
            "track",
            "ready",
            "alias",
            "debug",
            "page",
            "once",
            "off",
            "on",
            "addSourceMiddleware",
            "addIntegrationMiddleware",
            "setAnonymousId",
            "addDestinationMiddleware"
          ];
          analytics.factory = function (e: any) {
            return function () {
              var t = Array.prototype.slice.call(arguments);
              t.unshift(e);
              analytics.push(t);
              return analytics;
            };
          };
          for (var e = 0; e < analytics.methods.length; e++) {
            var key = analytics.methods[e];
            analytics[key] = analytics.factory(key);
          }
          analytics.load = function (key: any, e: any) {
            var t = document.createElement("script");
            t.type = "text/javascript";
            t.async = !0;
            t.src = "https://cdn.stormly.com/assets/tracking/analytics.min.js";
            var n = document.getElementsByTagName("script")[0];
            n.parentNode.insertBefore(t, n);
            analytics._loadOptions = e;
          };
          analytics._cdn = `https://t.stormly.com/client/segment/arn/settings/${stormlyKey}`;
          analytics._writeKey = stormlyKey;
          analytics.SNIPPET_VERSION = "4.15.3";
          analytics.load(stormlyKey, {
            integrations: {
              "Segment.io": {
                apiHost: `t.stormly.com/client/segment/ajs/api/${stormlyKey}`,
                deliveryStrategy: null,
                protocol: "https"
              }
            }
          });
        }
    })();
  }
}

const instance = new StormlyService();

export default instance;
